const nameToVanityURL = (name) => name.match(/(\w|\.)+/g).join('-').toLowerCase();
export default nameToVanityURL;
